import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d8e1378"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card bg-light reports--section" }
const _hoisted_2 = { class: "card-header section-header" }
const _hoisted_3 = { class: "h4 mb-0" }
const _hoisted_4 = { class: "card-body" }

import { computed, provide } from 'vue';
import { checkitem } from "@/utilities";
import { Room, Section, Type, Item } from "@/models";
import ReportRoomType from "@/components/depository/Type.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Section',
  props: {
    index: {},
    room: {},
    section: {}
  },
  setup(__props: any) {

const props = __props;

provide('sectionIndex', props.index);

const typeswithdeductions = computed(() => {
  let types: Type[] = props.section?.types.filter((type: Type) =>
    checktype(props.room, props.section, type)
  );
  return types;
});
const getTypeIndex = (type: Type): number => {
  return props.section?.types.findIndex((t: Type) => t._uuid === type._uuid) ?? -1;
};
const checktype = (room: Room, section: Section, type: Type): boolean => {
  let result = type?.items.filter((item: Item) => checkitem(room, section, type, item));
  return result?.length > 0;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.section.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeswithdeductions.value, (type) => {
        return (_openBlock(), _createElementBlock("div", {
          key: type._uuid
        }, [
          _createVNode(ReportRoomType, {
            room: _ctx.room,
            section: _ctx.section,
            type: type,
            index: getTypeIndex(type)
          }, null, 8, ["room", "section", "type", "index"])
        ]))
      }), 128))
    ])
  ]))
}
}

})